/**
 * Parses and validates a practice's Cal.com team id.
 */
export function parseCalTeamId({
  calTeamId,
  practiceId,
}: {
  calTeamId?: string;
  practiceId: string;
}): number {
  const normalizedTeamId = calTeamId?.trim();

  if (!normalizedTeamId) {
    throw new Error(`Practice ${practiceId} does not have a Cal.com team configured`);
  }

  if (!/^\d+$/.test(normalizedTeamId)) {
    throw new Error(`Invalid Cal.com team ID "${calTeamId}" for practice ${practiceId}`);
  }

  return Number.parseInt(normalizedTeamId, 10);
}
